module.exports = __webpack_public_path__ + "492ebe47bdbd149baf3d964af065fae8.pdf";